/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_LabelInputs */

const en_site_url_label = /** @type {(inputs: Site_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website address`)
};

const id_site_url_label = /** @type {(inputs: Site_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat website`)
};

/**
* | output |
* | --- |
* | "Website address" |
*
* @param {Site_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_label = /** @type {((inputs?: Site_Url_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_label(inputs)
	return en_site_url_label(inputs)
});